/**
 * Created by lishuang on 2016/12/12.
 */
import $ from "jquery";

//get error message from a response.
export function getErrorMessage(response) {

	console.error("Error:");
	console.error(response);

	let msg = "服务器出错，请稍后再试!";
	if (response["message"]) {
		msg = response["message"];
	} else {
		let temp = response["data"];
		if (temp !== null && typeof temp === "object") {
			if (temp["message"]) {
				msg = temp["message"];
			} else {
				if (temp["error"] && temp["error"]["message"]) {
					msg = temp["error"]["message"];
				}
			}
		}

	}

	return msg;
}


//copy all objB's value to objA. Recursive.
export function updateObject(objA, objB) {
	$.extend(objA, objB);
}


//human readable file size
export function humanFileSize(bytes, si = false) {
	let thresh = si ? 1024 : 1000;
	if (Math.abs(bytes) < thresh) {
		return bytes + ' B';
	}
	let units = si
		? ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
		: ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	let u = -1;
	do {
		bytes /= thresh;
		++u;
	} while (Math.abs(bytes) >= thresh && u < units.length - 1);
	return bytes.toFixed(1) + ' ' + units[u];
}


//check whether an obj is number.
export function isInteger(obj) {
	return typeof obj === 'number' && obj % 1 === 0
}



// WEBPACK FOOTER //
// ./src/common/util/Utils.js